import type { SerializedParagraphNode } from '@payloadcms/richtext-lexical';
import type { LexicalRoot, RichTextContent } from '@/payload/components/RichText/RichText';
import type { NodeTypes } from '@/payload/components/RichText/serialize';
import { isListItemNode, isOrderedListNode } from '@/payload/components/RichText/utils';

const INLINE_NODE_TYPES = new Set<NodeTypes['type']>(['text', 'link', 'autolink', 'linebreak']);

export function nodesToMetrolineContentParts(root?: LexicalRoot): Array<RichTextContent & { _key: string }> {
	if (!root) return [];

	const ol = root.children.find(isOrderedListNode);
	if (ol) {
		const parts = [];
		const olChildren = ol.children;
		for (const [i, listItem] of olChildren.entries()) {
			if (!isListItemNode(listItem)) continue;
			const listItemChildren = listItem.children;
			if (!listItemChildren.length) continue;

			const paragraphList = listItemChildrenToParagraphList(listItemChildren);
			parts.push({
				_key: `metroline-step-${i}-${paragraphList.length}`,
				root: {
					type: root.type,
					direction: root.direction,
					format: root.format,
					indent: root.indent,
					version: root.version,
					children: paragraphList,
				},
			});
		}
		return parts;
	}

	return [];
}

function listItemChildrenToParagraphList(nodes: NodeTypes[]): NodeTypes[] {
	const everyNodeIsInline = nodes.every((n) => INLINE_NODE_TYPES.has(n.type));
	if (!everyNodeIsInline) return nodes;

	const paragraph: SerializedParagraphNode = {
		type: 'paragraph',
		direction: null,
		format: '',
		textFormat: 0,
		indent: 0,
		version: 1,
		children: nodes,
	};

	return [paragraph];
}
